import { Component, Input } from '@angular/core';
import { MSG_TYPES } from '../../constants/common.constants';

@Component({
  standalone: false,
  selector: 'ui-message',
  templateUrl: './ui-message.component.html',
  styleUrls: ['./ui-message.component.scss']
})
export class UiMessageComponent {
  @Input() showIcon: boolean = true;
  @Input() type: string;
  @Input() title: string;
  @Input() size: 'md' = null;

  public ICONS_MAP = {
    [MSG_TYPES.ERROR]: 'icon-triangle-warning',
    [MSG_TYPES.INFO]: 'icon-circle-info',
    [MSG_TYPES.SUCCESS]: 'icon-circle-ok',
  };

  public MSG_TYPES = MSG_TYPES;
}
